import SearchInputSection from "./SearchInputSection";
import TopSearches from "./TopSearches";
import { SearchMainProps } from '../Types/SectionSmartSearchMainTypes';
import React, { useState } from "react";

const SectionSmartSearchMain = ({ content }: SearchMainProps) => {
  const [category, setCategory] = useState<string>("");

  return (
    <div className="search-container search-main-div">
      <div className="spring">
        <SearchInputSection category={category} setCategory={setCategory} content={content} navigateSlug={content.searchResultsPageSlug} />
        <TopSearches content={content} category={category} navigateSlug={content.searchResultsPageSlug} data-testid="top-search" />
      </div>
    </div>
  );
};
export default SectionSmartSearchMain;